import getImageResizerPath from "shared/util/getImageResizerPath";
import getPlaceholderImageUrl from "shared/util/getPlaceholderImageUrl";

/**
 * Get an image url.
 *
 * @param {str} picid - the picture's id
 * @returns {str} - the image url
 */
const GetUrlFromPicid = (picid) => {
	if (!picid || picid === "") {
		return getPlaceholderImageUrl();
	}

	const resizerPath = getImageResizerPath();
	const crop = "0x0";
	const dimensions = "800x800";
	const translations = "0";
	const fileType = "jpeg";

	return `${resizerPath}/${crop}/${dimensions}/${translations}/${picid}.${fileType}`;
};

export default GetUrlFromPicid;



// WEBPACK FOOTER //
// ./src/shared/util/GetUrlFromPicid.js